var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-up-type summary-list"},[_vm._t("txtWithoutAuto",function(){return [_c('p',[_vm._v("Du hast keine Aufladung ausgewählt")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }